module.exports = __webpack_public_path__ + "media/images/humidity-green-07d35c860dd8c9097b9c6d0247759523.svg";